var map = {
	"./addresses/address-form-dialog.app.vue": "7bd3",
	"./addresses/address-select.app.vue": "db76",
	"./addresses/customer-address-list.app.vue": "6474",
	"./addresses/customer-address.app.vue": "327a",
	"./attribute/attribute-form-dialog.app.vue": "e17b",
	"./attribute/attribute-value-form-dialog.app.vue": "24c2",
	"./cart/cart-btn.app.vue": "c8f4",
	"./cart/cart-dropdown.app.vue": "517d",
	"./charts/chart-stats-qty-modeltype.app.vue": "bf3b",
	"./country/country-select.app.vue": "8063",
	"./customers/customer-grid-card.app.vue": "a215",
	"./customers/customer-select.app.vue": "1cff",
	"./customers/form/customer-form-dialog.app.vue": "4650",
	"./files/file-image.app.vue": "508b",
	"./files/file-manager.app.vue": "497d",
	"./files/file-thumbnail.app.vue": "3d83",
	"./files/file-upload.app.vue": "074d",
	"./files/multi-file-upload.app.vue": "016b",
	"./files/single-file-upload.app.vue": "10d0",
	"./language/language-select.app.vue": "a602",
	"./language/translation-form-dialog.app.vue": "07b0",
	"./product-categories/category-selector.app.vue": "7ab1",
	"./product-categories/product-category-form-dialog.app.vue": "45aa",
	"./products/add-to-cart-form-modal.app.vue": "67cf",
	"./products/add-to-cart-form.app.vue": "c35d",
	"./products/form-shop-card.app.vue": "eab3",
	"./products/product-form-dialog.app.vue": "9bf4",
	"./products/product-selector-dialog.app.vue": "7941",
	"./products/product-shop-card.app.vue": "5f06",
	"./products/quick-add-form-btn.app.vue": "e4ba",
	"./reports/tag-watch-form-dialog.app.vue": "2244",
	"./shops/shop-form-dialog.app.vue": "ec50",
	"./shops/shop-select.app.vue": "c4ab",
	"./shops/shop-tags.app.vue": "3f4d",
	"./specs/default-specs.app.vue": "438e",
	"./stats/quantity-donut.app.vue": "3575",
	"./stats/quantity-stat.app.vue": "df13",
	"./status/status-badge.app.vue": "c0e9",
	"./status/status-card.app.vue": "2551",
	"./suppliers/form/supplier-form-dialog.app.vue": "9cb7",
	"./suppliers/supplier-grid-card.app.vue": "a1d2",
	"./suppliers/supplier-select.app.vue": "bbc8",
	"./users/user-form-dialog.app.vue": "0585",
	"./vat_rates/vat-select.app.vue": "4f4f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b594";